import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';


interface NotificationPageItemType {
    imgSrc?: string;
    isStart?: boolean;
    homepage?: boolean;
}

type ImageContainerType = Pick<NotificationPageItemType, 'imgSrc'>;

export const ImageContainer = styled('div', { label: 'ImageContainer' })<ImageContainerType>`
    ${({ imgSrc }): string => imgSrc === undefined ? '' : `background-image: url(${imgSrc})`};
    background-size: cover;
    height: 168px;
    min-width: 176px;
`;

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    margin-left: 32px;
    width: 100%;
`;

export const BannerLink = styled('a', { label: 'BannerLink' })`
    color: ${mainColors.default.light};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    margin-left: 6px;
    text-decoration: none;
    &:hover {
        color: ${mainColors.main.secondary};
    }
`;

export const LinkWrapper = styled('div', { label: 'LinkWrapper' })`
    background: ${lpPageColors.indicatorBlue};
    border: 1px solid ${mainColors.main.secondary};
    padding: 20px 0px;
`;

export const BannerWrapper = styled('div', { label: 'BannerWrapper' })`
    background-color: ${lpPageColors.paleGrey};
    border: 1px solid ${lpPageColors.indicatorBlue};
    height: 168px;
    min-width: 176px;
    padding: 52px 15px;
`;

export const VideoWrapper = styled('div', { label: 'VideoWrapper' })`
    background-color: ${lpPageColors.paleGrey};
    border: 1px solid ${lpPageColors.indicatorBlue};
    height: 168px;
    min-width: 176px;
`;

export const CampaignName = styled('div', { label: 'CampaignName' })`
    color: ${mainColors.main.primary};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    padding-bottom: 22px;
`;

export const DatesContainer = styled('div', { label: 'DatesContainer' })`
    display: flex;
`;

type DateWrapperType = Pick<NotificationPageItemType, 'isStart'>;

export const DateWrapper = styled('div', { label: 'DateWrapper' })<DateWrapperType>`
    ${({ isStart }): string => isStart === true ? 'margin-right: 16px;' : ''};
`;

export const DateTitle = styled('div', { label: 'DateTitle' })`
    color: ${mainColors.grays.gray400};
    font-size: 12px;
    line-height: 1.33;
`;

export const DateValue = styled('div', { label: 'DateValue' })`
    font-size: ${fontSize.xRegular};
    line-height: 1.2;
`;

// For copy to clipboard functionality
export const TextAreaCopyComponent = styled('textarea', { label: 'TextAreaCopyComponent' })`
    border: 0;
    display: block;
    height: 0;
    margin: 0;
    opacity: 0;
    width: 0;
`;

export const CopyComponentWrapper = styled('div', { label: 'CopyComponentWrapper' })`
    width: 0;
    height: 0;
`;

type IndicatorType = Pick<NotificationPageItemType, 'homepage'>;

export const Indicator = styled('div', { label: 'Indicator' })<IndicatorType>`
    background-color: ${({ homepage }): string => homepage === undefined ? lpPageColors.indicatorBlue : lpPageColors.homepageIndicatorBg};
    border-radius: 15px;
    color: ${mainColors.default.light};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    margin-right: 8px;
    padding: 2px 7px;
`;

export const IndicatorsWrapper = styled('div', { label: 'IndicatorsWrapper' })`
    display: flex;
    margin: 18px 0 20px 0;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: 12px;
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;
